import { createAction, union } from '@ngrx/store';
import { UserReservation } from '../../../models/user-reservation/user-reservation';

export const storeUserReservation = createAction(
  'UserReservationActions storeUserReservation',
  (payload: UserReservation | null) => ({ payload }),
);

export const clearUserReservation = createAction(
  'UserReservationActions clearUserReservation',
);

const all = union({
  storeUserReservation,
  clearUserReservation,
});
export type UserReservationActionsUnion = typeof all;
